import { render, staticRenderFns } from "./RelatedItemsConstructor.vue?vue&type=template&id=37977c21"
import script from "./RelatedItemsConstructor.vue?vue&type=script&lang=js"
export * from "./RelatedItemsConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37977c21')) {
      api.createRecord('37977c21', component.options)
    } else {
      api.reload('37977c21', component.options)
    }
    module.hot.accept("./RelatedItemsConstructor.vue?vue&type=template&id=37977c21", function () {
      api.rerender('37977c21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/related-items-constructor/RelatedItemsConstructor.vue"
export default component.exports